<template>
    <PlazosImpagados :plazos="plazos" :filters="filters" @actualizado="getPlazos"></PlazosImpagados>
</template>

<script>
import PlazosImpagados from '@/components/backend/components/plazos/PlazosImpagados';

export default {
    data() {
        return {
            plazos: { meta: { current_page: 1 } },
            categorias: [],
            loading: false,
            filters: {
                per_page: 10,
                page: 1,
                estado: '',
                fecha: ''
            },
        }
    },
    methods: {
        getPlazos() {
            this.loading = true;
            
            let params = {
                filters: this.filters,
                lista_id: this.lista.id
            };

            this.$store.dispatch(this.config.getVuexAlias('back.plazos-impagados.abonos'), params).then(res => {
                this.plazos = res.data;
            }).finally(() => this.loading = false);
        }
    },
    created() {
        this.getPlazos();
    },
    computed: {
        lista() {
            return this.$store.getters.getListaActiva;
        }
    },
    components: {
        PlazosImpagados
    }
}
</script>